import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import { handleUpdateProjectResource } from '@/service/projectService';

/**
 * isDisableBtnDeleteB2B
 * Check disable btn delete B2B
 * @param {*} argsAll
 * @param {*} project
 * @returns
 */
export const isDisableBtnDeleteB2B = (argsAll, project) => {
    if( !argsAll.projectDetail.isDesk ) return true;

    if (
        Utils.isEmptyObject(project) ||
        project.status === Constant.B2B_CUSTOMER_PROJECT_STATUS.DELETED
    ) {
        return true;
    }
    return false;
};

/**
 * onClickDeleteB2BCustomer
 * @param {*} argsAll
 * @param {*} project
 * @returns
 */
export const onClickDeleteB2BCustomer = async (argsAll, project) => {
    if (isDisableBtnDeleteB2B(argsAll, project)) {
        return;
    }

    argsAll.setIsOpenDialogConfirmDelete(true);
    argsAll.setSelectedB2BCustomer(project);
};

/**
 * handleSubmitDeleteB2BCustomer
 * @param {*} argsAll 
 * @param {*} project 
 * @returns 
 */
export const handleSubmitDeleteB2BCustomer = async (argsAll, project) => {
    if (isDisableBtnDeleteB2B(argsAll, project) || !project.id) {
        return;
    }

    argsAll.setSelectedB2BCustomer({});
    argsAll.setIsOpen(false);
    argsAll.setIsLoading(true);

    let ticketId = project.id;
    if (project.status !== Constant.B2B_CUSTOMER_PROJECT_STATUS.ACTIVE && project.ticketId) {
        ticketId = project.ticketId;
    }

    let requestDeleteB2BParams = {
        method: Constant.UPDATE_PROJECT_RESOURCE_METHOD.DELETE_B2B_CUSTOMER,
        corporationId: argsAll.corporationDetail.id,
        userId: argsAll.userDetail.id,
        projectId: argsAll.projectId,
        b2bCustomerId: project.id,
        ticketId: ticketId,
        project: JSON.stringify(project)
    }

    let updateResult = await handleUpdateProjectResource(argsAll.API, requestDeleteB2BParams);
    if (!updateResult || !updateResult.status) {
        argsAll.setIsLoading(false);
        return;
    }

    // update state
    let currentB2BCustomerList = cloneDeep(argsAll.b2bCustomerList);
    let indexInB2BCustomerList = Utils.findIndexInArrayById(project.id, currentB2BCustomerList);
    if (indexInB2BCustomerList !== -1) {
        currentB2BCustomerList[indexInB2BCustomerList].status = Constant.B2B_CUSTOMER_PROJECT_STATUS.DELETED;
        argsAll.setB2BCustomerList(currentB2BCustomerList);
    }
    //reload panel helpdesk list
    argsAll.reloadTicketListByPanelType({panelType: Constant.PANEL_TYPE.HELPDESK_TICKET_LIST});
    argsAll.setIsLoading(false);
    return;
}



/**
 * 
 * @param {*} b2bCustomerActiveList 
 * @param {*} b2bCustomerWaitingAndRejectList 
 * @returns 
 */
 export const filterResultB2BProject = (b2bCustomerActiveList, b2bCustomerWaitingAndRejectList) => {
    // Validate skip deleted corp
    b2bCustomerActiveList = b2bCustomerActiveList.filter(project => project.orgActive !== Constant.CORPORATION_ACTIVE.DELETED);
    b2bCustomerWaitingAndRejectList = b2bCustomerWaitingAndRejectList.filter(project => project.orgActive !== Constant.CORPORATION_ACTIVE.DELETED);

    for(let i=0; i<b2bCustomerActiveList.length; i++){
        for(let j=0; j<b2bCustomerWaitingAndRejectList.length; j++){
            if(b2bCustomerActiveList[i].id === b2bCustomerWaitingAndRejectList[j].id){
                b2bCustomerWaitingAndRejectList[j].isDisable = true;
                b2bCustomerActiveList[i].updatedAt = b2bCustomerWaitingAndRejectList[j].updatedAt;
                if(b2bCustomerActiveList[i].status !== Constant.STATUS_OF_USER.ACTIVE){
                    b2bCustomerActiveList[i].status = b2bCustomerWaitingAndRejectList[j].status;
                    b2bCustomerActiveList[i].id = b2bCustomerWaitingAndRejectList[j].ticketId;
                    b2bCustomerActiveList[i].isTicket = true;
                }
            }
            if(Utils.isEmpty(b2bCustomerWaitingAndRejectList[j].orgName) || Utils.isEmptyString(b2bCustomerWaitingAndRejectList[j].orgName)){
                b2bCustomerWaitingAndRejectList[j].orgName = Constant.NONAME;
            }
            if(Utils.isEmpty(b2bCustomerWaitingAndRejectList[j].projectName) || Utils.isEmptyString(b2bCustomerWaitingAndRejectList[j].projectName)){
                b2bCustomerWaitingAndRejectList[j].projectName = Constant.NONAME;
            }
        }
        if(Utils.isEmpty(b2bCustomerActiveList[i].orgName) || Utils.isEmptyString(b2bCustomerActiveList[i].orgName)){
            b2bCustomerActiveList[i].orgName = Constant.NONAME;
        }
        if(Utils.isEmpty(b2bCustomerActiveList[i].projectName) || Utils.isEmptyString(b2bCustomerActiveList[i].projectName)){
            b2bCustomerActiveList[i].projectName = Constant.NONAME;
        }
    }
    return [b2bCustomerActiveList, b2bCustomerWaitingAndRejectList]
}
